import { useAllCorporate } from "../../hooks/products/corporate/useAllCorporate";
import { useAllPension } from "../../hooks/products/pension/useAllPension";

import React from "react";
import RetailIcon from '../../assets/UiElements/retail-green.svg';
import LifeIcon from '../../assets/UiElements/life-green.svg';
import { useAllLife } from "../../hooks/products/life/useAllLife";
import CorporateIcon from '../../assets/UiElements/corporate-green.svg';
import { useNavigate } from "react-router-dom";
import { RightOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { notifyUser } from '../../util/util';
  function Transactions() {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);

  const { data: allCorporateData } = useAllCorporate();
  React.useEffect(() => {
    if (allCorporateData) {
      console.log("Fetched all corporate policies:", allCorporateData);
    }
  }, [allCorporateData]);
  // Tabs removed, always show all products
  const { data: allLifeData } = useAllLife();
  React.useEffect(() => {
    if (allLifeData) {
      console.log("Fetched all life policies:", allLifeData);
    }
  }, [allLifeData]);
  // Fetch all pension policies and log the data
  const { data: allPensionData } = useAllPension();
  React.useEffect(() => {
    if (allPensionData) {
      console.log("Fetched all pension policies:", allPensionData);
    }
  }, [allPensionData]);

    // Example product data (should be synced with backend in real app)
  // Get dynamic count for Life products from API
  const lifeCount = allLifeData?.data?.policy_details?.length;
  // Helper to convert number to words (supports 0-20, fallback to number)
  const numberToWords = (n) => {
    const words = [
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
      "twenty",
    ];
    if (typeof n === "number" && n >= 0 && n <= 20) {
      const word = words[n];
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
    return n;
  };
  // Get dynamic count for Pension products from API
  const pensionCount = Array.isArray(allPensionData?.data)
    ? allPensionData.data.length
    : undefined;

    // Example product data (should be synced with backend in real app)
    const allProducts = [
      {
        id: 'prod1',
        name: 'Life',
        number:
          lifeCount !== undefined
            ? `You Have ${numberToWords(lifeCount)} Product${
                lifeCount === 1 ? "" : "s"
              }`
            : "You Have Products",
        status: 'inforce',
        icon: <img src={LifeIcon} alt="Life" style={{ width: 36, height: 36, marginRight: 24 }} />,
        onClick: () => {
                      setLoading(true);
                      navigate('/dashboard/lifepage/transactions');
                    },
      },
      {
        id: 'prod2',
        name: 'Pension',
        number:
          pensionCount !== undefined
            ? `You Have ${numberToWords(pensionCount)} Product${
                pensionCount === 1 ? "" : "s"
              }`
            : "You Have Products",
        status: 'expired',
        icon: <img src={RetailIcon} alt="Retail" style={{ width: 36, height: 36, marginRight: 24 }} />,
        onClick: () => {
                      setLoading(true);
                      navigate('/dashboard/pensionpage/transactions');
                    },
      },
      {
        id: 'prod3',
        name: 'Corporate',
        // Get dynamic count for Corporate products from API
        number:
          Array.isArray(allCorporateData?.data)
            ? `You Have ${numberToWords(allCorporateData.data.length)} Product${allCorporateData.data.length === 1 ? '' : 's'}`
            : "You Have Products",
        status: 'lapsed',
        icon: <img src={CorporateIcon} alt="Corporate" style={{ width: 36, height: 36, marginRight: 24 }} />,
        onClick: () => {
          if (process.env.REACT_APP_COMING_SOON_BUTTONS === 'true') {
            notifyUser('info', 'Coming Soon!', 'Info');
          } else {
            navigate('/dashboard/corporate/transactions');
          }
        },
      },
      // Add more products as needed
    ];

  // Filter out Corporate if HIDE_CORPORATE is true
  const hideCorporate = process.env.REACT_APP_HIDE_CORPORATE === 'true';
  const filteredProducts = hideCorporate 
    ? allProducts.filter(product => product.id !== 'prod3')
    : allProducts;

    return (
    <div className="products-page-root" style={{
      padding: 16
    }}>
 
  <div className="products-page-container" style={{ maxWidth: 1200, margin: '0 auto', paddingTop: 40, width: '100%' }}>
        <div className="products-card-list" style={{
          background: '#fff',
          borderRadius: 28,
          boxShadow: '0 8px 40px 0 rgba(0,0,0,0.10)',
          padding: '56px 64px',
          minWidth: 320,
          maxWidth: 900,
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 18
        }}>
          {/* Tabs removed */}
          <h2 style={{ fontWeight: 700, fontSize: 24, color: '#222', marginBottom: 0, textAlign: 'left' }}>Select product to view transactions</h2>
       
          <div style={{ width: '100%', height: 2, background: '#e0e0e0', borderRadius: 1, marginBottom: 18 }} />
          {/* All Products List (no grouping) */}
          <div style={{ width: '100%' }}>
            {filteredProducts.length === 0 ? (
              <div style={{ color: '#888', fontSize: 16, margin: '12px 0 24px 0' }}>No products found.</div>
            ) : (
              filteredProducts.map(product => (
                <div
                  key={product.id}
                  className="insure-row-hover product-row"
                  tabIndex={0}
                  role="button"
                  aria-label={`Go to ${product.name}`}
                  onClick={product.onClick}
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') product.onClick(); }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: 70,
                    borderRadius: 14,
                    padding: '12px 18px',
                    marginBottom: 0,
                    borderBottom: '1px solid #eee',
                    cursor: 'pointer',
                    transition: 'background 0.18s',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                    {product.icon}
                  </div>
                  <div className="product-row-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, minWidth: 0 }}>
                    <span className="product-row-title" style={{ fontWeight: 500, fontSize: 21, color: '#111', lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{product.name}</span>
                    <span className="product-row-number" style={{
                      color: '#888',
                      fontWeight: 500,
                      fontSize: 15,
                      letterSpacing: 1,
                      marginBottom: 2,
                      lineHeight: 1.1,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>{product.number}</span>
                  </div>
                  <div style={{ flexShrink: 0, marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                    <RightOutlined className="product-row-arrow" style={{ fontSize: 26, color: '#bbb' }} />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <style>{`
          .insure-row-hover:hover, .insure-row-hover:focus {
            background: linear-gradient(90deg, #e6f9ed 0%, #d2f7e3 100%) !important;
          }
          /* Responsive main card header */
          .products-card-list h2 {
            font-size: 24px;
          }
          @media (max-width: 768px) {
            .products-card-list h2 { 
              font-size: 20px !important; 
              padding-left: 16px !important;
            }
            .products-page-root {
              padding: 6px !important;
            }
            .products-page-container {
              padding-top: 18px !important;
            }
            .products-card-list {
              padding: 24px 6px !important;
              border-radius: 14px !important;
            }
            .product-row {
              min-height: 54px !important;
              padding: 8px 8px !important;
              display: flex !important;
              align-items: center !important;
              border-bottom: 1px solid #eee;
              border-radius: 12px;
            }
            .product-row-title {
              font-size: 16px !important;
            }
            .product-row-number {
              font-size: 12px !important;
            }
            .product-row-arrow {
              font-size: 18px !important;
              margin-left: 0 !important;
            }
            .product-row img {
              width: 26px !important;
              height: 26px !important;
              margin-right: 12px !important;
            }
          }
          @media (max-width: 600px) {
            .products-page-root {
              padding: 2px !important;
            }
            .products-page-container {
              padding-top: 8px !important;
            }
            .products-card-list {
              padding: 12px 2px !important;
              border-radius: 8px !important;
            }
            .products-card-list h2 { font-size: 16px !important; padding-left: 16px !important; }
            .product-row {
              min-height: 44px !important;
              padding: 6px 8px !important;
              display: flex !important;
              align-items: center !important;
              border-bottom: 1px solid #eee;
              border-radius: 8px;
            }
            .product-row-title {
              font-size: 13px !important;
            }
            .product-row-number {
              font-size: 10px !important;
            }
            .product-row-arrow {
              font-size: 14px !important;
              margin-left: 0 !important;
            }
            .product-row img {
              width: 18px !important;
              height: 18px !important;
              margin-right: 12px !important;
            }
          }
        `}</style>
        
        {/* Loading Overlay */}
        {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}>
            <Spin size="large" tip="Loading..." />
          </div>
        )}
      </div>
    </div>
  );
}

export default Transactions;
